import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

/**
 * 事例アーカイブ用 Swiper を初期化する
 * @param {HTMLElement|string} selector
 */
export const initArchiveCaseSwiper = (selector = '.m-archive-case.swiper') => {
  const containers = typeof selector === 'string' ? document.querySelectorAll(selector) : [selector];

  containers.forEach((container) => {
    // すでに初期化済みの場合はスキップ
    if (container.classList.contains('swiper-initialized')) return;

    const isThreeSlides = container.classList.contains('swiper--three-slides');
    const isTwoSlides = container.classList.contains('m-archive-case--col2');
    const isMenu = container.classList.contains('m-archive-case--menu');

    // --menu もしくは --three-slides の場合は3列表示にする
    const forceThreeSlides = isThreeSlides || isMenu;

    let nextEl, prevEl;
    if (isMenu) {
      // 既存の特定構造（/menu/xxxx/ 用）に対応
      const parent = container.closest('.p-menu-detail__related-cases') || container.parentElement;
      nextEl = parent.querySelector('.m-archive-case-nav__next--menu');
      prevEl = parent.querySelector('.m-archive-case-nav__prev--menu');
    } else {
      // 通常（/business/integration/ など）
      const section = container.closest('section') || container.closest('.p-business-integration__case-container') || container.parentElement;
      nextEl = section.querySelector('.m-archive-case-nav__next');
      prevEl = section.querySelector('.m-archive-case-nav__prev');
    }

    // 設定値の決定
    let slidesPerViewSP = 1.2;
    let slidesPerViewPC = 2.2;
    let spaceBetweenPC = 20;

    if (forceThreeSlides) {
      slidesPerViewSP = 1;
      slidesPerViewPC = 3;
      spaceBetweenPC = 32;
    } else if (isTwoSlides) {
      slidesPerViewPC = 2;
      spaceBetweenPC = 24;
    }

    new Swiper(container, {
      modules: [Navigation],
      loop: false,
      slidesPerView: slidesPerViewSP,
      spaceBetween: 16,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        769: {
          slidesPerView: slidesPerViewPC,
          spaceBetween: spaceBetweenPC,
        },
      },
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initArchiveCaseSwiper();
});
